import React from 'react'

function ShopArea() {
  return (
	<section className="shop-area pt-120 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-lg-4 col-sm-6">
              <div className="accessories-item text-center mb-80">
                <div className="accessories-thumb mb-30">
                  <a href="/#"><img src="assets/img/product/shop_item01.jpg" alt="" /></a>
                </div>
                <div className="accessories-content">
                  <h5><a href="/#">Gaming T-Shirt</a></h5>
                  <span>Price: $12.00</span>
                  <a href="/#" className="shop-add-action">Add to cart</a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="accessories-item text-center mb-80">
                <div className="accessories-thumb mb-30">
                  <a href="/#"><img src="assets/img/product/shop_item02.jpg" alt="" /></a>
                </div>
                <div className="accessories-content">
                  <h5><a href="/#">Gaming backpack</a></h5>
                  <span>Price: $19.00</span>
                  <a href="/#" className="shop-add-action">Add to cart</a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="accessories-item text-center mb-80">
                <div className="accessories-thumb mb-30">
                  <a href="/#"><img src="assets/img/product/shop_item03.jpg" alt="" /></a>
                </div>
                <div className="accessories-content">
                  <h5><a href="/#">xbox one controller</a></h5>
                  <span>Price: $14.00</span>
                  <a href="/#" className="shop-add-action">Add to cart</a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="accessories-item text-center mb-80">
                <div className="accessories-thumb mb-30">
                  <a href="/#"><img src="assets/img/product/shop_item04.jpg" alt="" /></a>
                </div>
                <div className="accessories-content">
                  <h5><a href="/#">Gaming T-Shirt</a></h5>
                  <span>Price: $12.00</span>
                  <a href="/#" className="shop-add-action">Add to cart</a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="accessories-item text-center mb-80">
                <div className="accessories-thumb mb-30">
                  <a href="/#"><img src="assets/img/product/shop_item05.jpg" alt="" /></a>
                </div>
                <div className="accessories-content">
                  <h5><a href="/#">Gaming backpack</a></h5>
                  <span>Price: $19.00</span>
                  <a href="/#" className="shop-add-action">Add to cart</a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="accessories-item text-center mb-80">
                <div className="accessories-thumb mb-30">
                  <a href="/#"><img src="assets/img/product/shop_item06.jpg" alt="" /></a>
                </div>
                <div className="accessories-content">
                  <h5><a href="/#">Joy‑Con controllers</a></h5>
                  <span>Price: $14.00</span>
                  <a href="/#" className="shop-add-action">Add to cart</a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="accessories-item text-center mb-80">
                <div className="accessories-thumb mb-30">
                  <a href="/#"><img src="assets/img/product/shop_item07.jpg" alt="" /></a>
                </div>
                <div className="accessories-content">
                  <h5><a href="/#">nintendo switch</a></h5>
                  <span>Price: $12.00</span>
                  <a href="/#" className="shop-add-action">Add to cart</a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="accessories-item text-center mb-80">
                <div className="accessories-thumb mb-30">
                  <a href="/#"><img src="assets/img/product/shop_item08.jpg" alt="" /></a>
                </div>
                <div className="accessories-content">
                  <h5><a href="/#">xbox one controller</a></h5>
                  <span>Price: $19.00</span>
                  <a href="/#" className="shop-add-action">Add to cart</a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6">
              <div className="accessories-item text-center mb-80">
                <div className="accessories-thumb mb-30">
                  <a href="/#"><img src="assets/img/product/shop_item09.jpg" alt="" /></a>
                </div>
                <div className="accessories-content">
                  <h5><a href="/#">MaxGreen 5902 Blue</a></h5>
                  <span>Price: $14.00</span>
                  <a href="/#" className="shop-add-action">Add to cart</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  )
}

export default ShopArea